import React from 'react'
import { orderPaymentsLoad, orderPaymentEdit } from '../../../../redux/actions/order/orderPaymentActions';
import * as $ from 'jquery';
import { useDispatch } from 'react-redux';

export default function PaymentsButton(props) {
  const { orderId, children } = props
  const dispatch = useDispatch()

  const handlePaymentEdit = () => {
    dispatch(orderPaymentEdit('New'))
    // dispatch(orderPaymentsLoad(orderId, { filter: { payment_type: ['sale'] }, include: ['staff'] }))
    dispatch(orderPaymentsLoad(orderId, { rpp: 999, filter: { payment_type: ['sale', 'refund'], amount_present: true }, include: ['staff'] }))
    $("#orderPaymentsForm-modal").modal()
  }

  return (
    <span className="pointer" onClick={handlePaymentEdit}>
      {children}
    </span>
  )
}
